"use strict";

define(['app'], function (app) {
  return app.Backbone.Model.extend({
    defaults: {
      source: false,
      source_thumb: false,
      cropped: false
    },
    getAvatar: function getAvatar() {
      return this.get('source_thumb');
    },
    getFullAvatar: function getFullAvatar() {
      return this.get('source');
    }
  });
});